import { types } from 'mobx-state-tree';

import StatefulStore from '../models/StatefulStore';
import Modal from '../models/Modal';
import LocalizationSites from '../models/LocalizationSites';
import { getStorageAndParse, stringifyAndSetStorage } from '../util/storage';
import LocalStorageKey from '../types/LocalStorageKey';

const LocalizationStore = StatefulStore.named('LocalizationStore')
  .props({
    countryCode: types.maybeNull(types.string),
    sites: types.array(LocalizationSites),
    localizationModal: types.optional(Modal.named('LocalizationModal'), {})
  })
  .views((self) => {
    return {
      get suggestionEnabled() {
        return self.sites.length > 0;
      }
    };
  })
  .actions((self) => {
    const getLocalStorage = () => {
      return !!getStorageAndParse(LocalStorageKey.SITE_CHOSEN);
    };
    const setLocalStorage = () => {
      stringifyAndSetStorage(LocalStorageKey.SITE_CHOSEN, true);
    };
    const setup = (localization) => {
      if (localization) {
        self.countryCode = localization.countryCode;
        self.sites = localization.sites;
        self.suggestedSite = localization.suggestedSite;
      }
    };
    return {
      getLocalStorage,
      setLocalStorage,
      setup
    };
  });

export default LocalizationStore;



// WEBPACK FOOTER //
// ./src/store/LocalizationStore.js